import Swal from 'sweetalert2'
import { CLASSIC_SWAL_CLASS as MODERN_POINTS_SWAL_CLASS } from '../classicRewardRedeemHandlers'

function escapeHtml(value: string) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

type RedEnvelopeSwalTone = 'warning' | 'error' | 'success' | 'confirm' | 'info'

const TONE_META: Record<
  RedEnvelopeSwalTone,
  { wrapClass: string; icon: string }
> = {
  warning: { wrapClass: 'points-swal-icon-wrap--confirm', icon: 'fas fa-exclamation-triangle' },
  error: { wrapClass: 'points-swal-icon-wrap--error', icon: 'fas fa-times' },
  success: { wrapClass: 'points-swal-icon-wrap--success', icon: 'fas fa-check' },
  confirm: { wrapClass: 'points-swal-icon-wrap--confirm', icon: 'fas fa-envelope-open-text' },
  info: { wrapClass: 'points-swal-icon-wrap--info', icon: 'fas fa-info' },
}

/** SweetAlert ธีมระบบคะแนน (points-swal) — ให้ตรงกับหน้าแลกรางวัล */
export async function fireRedEnvelopeSwal(options: {
  title: string
  message: string
  tone?: RedEnvelopeSwalTone
  confirmText?: string
  cancelText?: string
  showCancel?: boolean
}) {
  const tone = options.tone || 'info'
  const meta = TONE_META[tone]

  return Swal.fire({
    title: options.title,
    html: `
      <div class="points-swal-body points-swal-body--center">
        <div class="points-swal-icon-wrap ${meta.wrapClass}" aria-hidden="true">
          <i class="${meta.icon}"></i>
        </div>
        <p class="points-swal-message">${escapeHtml(options.message)}</p>
      </div>
    `,
    showCancelButton: options.showCancel === true,
    confirmButtonText: options.confirmText || 'ตกลง',
    cancelButtonText: options.cancelText || 'ยกเลิก',
    reverseButtons: true,
    focusCancel: options.showCancel === true,
    buttonsStyling: false,
    customClass: MODERN_POINTS_SWAL_CLASS,
  })
}
